// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (max-width: 768px) {\n.row-container div[data-v-7891ba49],\n  .row-container span[data-v-7891ba49] {\n    font-size: 12px !important;\n}\n.row-container .status[data-v-7891ba49] {\n    border-right: unset !important;\n    border-bottom: 1px solid #e8e8e8;\n    padding-bottom: 10px;\n}\n[data-v-7891ba49] .reason em {\n    font-size: 10px !important;\n}\n[data-v-7891ba49] .reason .text-left {\n    font-size: 12px !important;\n}\n}", ""]);
// Exports
module.exports = exports;
